<template>
  <div class="table-tab__container" tabindex="1" style="overflow: hidden; outline: none;">
    <table class="table-tab__block table " style="width: 1200px">
      <thead class="table-tab__thead">
      <tr class="table-tab__height-auto-column-header" style="height: 48px;">
        <th>№ предложения</th>
        <th>Название контрагента</th>
<!--        <th>Статус протокола</th>-->
        <th>Голоc</th>
        <th>Мнение</th>
<!--        <th></th>-->
      </tr>
      </thead>
      <tbody class="table-tab__tbody">
          <tr class="table-tab__tr-border" v-for="record in table">
            <td>
              <router-link class="table-tab__color u-text-underline"
                           :to="{
                             name: 'purchases-public-lot-alien-bid',
                             params: {
                               lotId: record.bid.lotId,
                               requestId: record.bid.requestId,
                               bidId: record.bid.bidId,
                               tab: 'bid'
                             }
                           }">
                {{record.bid.name}}
              </router-link>
            </td>
            <td>{{record.organization}}</td>
<!--            <td>-->
<!--              <span v-if="record.status">{{$t(record.status.label)}}</span>-->
<!--            </td>-->

            <td>
              <template v-if="record.canVote">
                <dropdown-new :options="enums.Votes.options.all"
                              @change="onVoteChange(draft, record)"
                              v-model="record.vote">
                </dropdown-new>
              </template>

              <template>
<!--                <label class="u-margin-right-7" v-if="record.vote">{{$t(record.vote.label)}}</label>-->

                <v-popover class="d-inline-block" placement="bottom" v-if="record.votes.length">
                  <label class="u-red-color u-text-underline">Другие голоса</label>

                  <template slot="popover">
                    <div v-for="vote in record.votes">
                      {{vote.owner | fullName}} - {{$t(vote.vote.label)}}
                      <span v-if="vote.reason">
                        ({{vote.reason}})
                      </span>
                    </div>
                  </template>
                </v-popover>
              </template>
            </td>

            <td>
              <template v-if="record.canVote">
                <textarea class="a-textarea"
                          @change="onVoteChange(draft, record)"
                          v-model="record.reason"></textarea>
              </template>
            </td>

<!--            <td>-->
<!--              <button type="button"-->
<!--                      class="a-accordion__editing-btn"-->
<!--                      :title="$t('buttons.save')"-->
<!--                      @click.prevent="onVoteClick(draft, record)"-->
<!--                      v-if="record.canVote">-->
<!--                <img class="table-tab__img-4" src="@/assets/img/static/tab-ok.svg" alt="">-->
<!--              </button>-->
<!--            </td>-->
          </tr>
      </tbody>
      <tfoot v-if="draft.permissions.CAN_VOTE">
        <tr>
          <td colspan="2">По протоколу:</td>
          <td>
            <template v-if="draft.permissions.CAN_VOTE">
              <dropdown-new :options="enums.Votes.options.all"
                            @change="onTotalVoteChange(draft, total)"
                            v-model="total.vote">
              </dropdown-new>
            </template>
          </td>
          <td>
            <template v-if="draft.permissions.CAN_VOTE">
                <textarea class="a-textarea"
                          @change="saveVote(draft, total)"
                          v-model="total.reason"></textarea>
            </template>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default {
    props: {
      lot: {
        type: Object,
        required: true
      },

      draft: {
        type: Object,
        required: true
      }
    },

    computed: {
      total() {
        const total = _.find(this.draft.votes, {
          request: 0,
          bidNum: 0,
          owner: this.currentUser.id
        });

        return {
          bid: {
            requestId: 0,
            bidNum: 0
          },
          vote: _.get(total, 'vote', new this.enums.Votes(this.enums.Votes.EMPTY)),
          reason: _.get(total,'reason')
        }
      },

      table() {
        const result = [];

        for (const request of this.lot.requests) {
          if (request.state.DRAFT) continue;
          if (!this.draft.type.RECEIVING_REQUESTS && !this.draft.type.PROCESSING_REQUESTS && request.state.DECLINED) continue;

          for (const bid of request.bids) {
            if (!this.draft.type.RECEIVING_REQUESTS && !this.draft.type.PROCESSING_REQUESTS && bid.state.DECLINED) continue;

            const votes = this.lot.commission.map(m => {
              const v = _.find(this.draft.votes, {
                request: request.num,
                bidNum: bid.num,
                owner: m.id
              });

              return {
                owner: m,
                vote: _.get(v, 'vote', new this.enums.Votes(this.enums.Votes.EMPTY)),
                reason: _.get(v, 'reason')
              }
            });

            const status = _.get(_.find(this.draft.results, {
              request: request.num,
              bidNum: bid.num
            }), 'result');

            // const votes = _.filter(this.draft.votes, {
            //     request: request.num,
            //     bidNum: bid.num
            // }).map(v => ({
            //   owner: _.find(this.lot.commission, { id: v.owner }),
            //   vote: v.vote,
            //   reason: v.reason
            // }));

            const ownVote = _.find(this.draft.votes, {
              owner: this.currentUser.id,
              request: request.num,
              bidNum: bid.num
            });

            // let status = new this.enums.Votes(this.enums.Votes.NO);
            //
            // if (_.filter(this.draft.votes, v => v.vote.valueOf() === this.enums.Votes.YES).length > this.draft.votes.length / 2) {
            //   status = new this.enums.Votes(this.enums.Votes.YES);
            // }

            result.push(Vue.observable({
              bid: {
                lotId: this.lot.id,
                requestId: request.num,
                bidId: bid.id,
                bidNum: bid.num,
                name: `${this.lot.catalog.name} - ${request.num} - ${bid.num}`
              },

              organization: request.organization,
              votes: votes,
              status,
              vote: _.get(ownVote, 'vote'),
              reason:  _.get(ownVote, 'reason'),
              canVote: this.draft.permissions.CAN_VOTE && request.state.valueOf() !== this.enums.RequestState.DRAFT
            }));
          }
        }

        return result;
      }
    },

    methods: {
      onVoteChange(draft, record) {
        let totalVote;
        let totalReason = [];
        let countYes = 0;

        for (const record of this.table) {
          const vote = record.vote ? record.vote.valueOf() : undefined;

          if (vote === this.enums.Votes.NO) {
            totalVote = record.vote;
          }
          else if (!totalVote && vote === this.enums.Votes.DRAW) {
            totalVote = record.vote;
          }

          if (vote === this.enums.Votes.YES) {
            ++countYes;
          }

          if (record.reason) {
            totalReason.push(`${record.bid.name} - ${record.reason}`);
          }
        }

        if (countYes === this.table.length) {
          totalVote = this.enums.Votes.YES;
        }

        return this.runBlockerAction(async() => {
          try {
            await this.$store.dispatch('voteForDraft', {
              lotId: this.lot.id,
              requestId: record.bid.requestId,
              bidId: record.bid.bidNum,
              protocolType: draft.type,
              version: draft.version,
              vote: record.vote,
              reason: record.reason
            });

            totalReason = _.isEmpty(totalReason) ? undefined: totalReason.join(';\n');

            if (totalVote && this.total.vote.valueOf() !== totalVote.valueOf() || totalReason !== this.total.reason) {
              await this.$store.dispatch('voteForDraft', {
                lotId: this.lot.id,
                requestId: 0,
                bidId: 0,
                protocolType: draft.type,
                version: draft.version,
                vote: totalVote,
                reason: totalReason
              });
            }
          }
          catch(e) {
            console.error('failed voting for draft protocol', e);
          }
        })
      },

      onTotalVoteChange(draft, record) {
        return this.runBlockerAction(async() => {
          try {
            await this.$store.dispatch('voteForDraft', {
              lotId: this.lot.id,
              requestId: record.bid.requestId,
              bidId: record.bid.bidNum,
              protocolType: draft.type,
              version: draft.version,
              vote: record.vote,
              reason: record.reason
            });

            if (record.vote.valueOf() === this.enums.Votes.YES) {
              for (const item of this.table) {
                if (!item.vote || item.vote.valueOf() !== this.enums.Votes.YES) {
                  await this.$store.dispatch('voteForDraft', {
                    lotId: this.lot.id,
                    requestId: item.bid.requestId,
                    bidId: item.bid.bidNum,
                    protocolType: draft.type,
                    version: draft.version,
                    vote: this.enums.Votes.YES,
                    reason: item.reason
                  });
                }
              }
            }
          }
          catch(e) {
            console.error('failed voting for draft protocol', e);
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
